import React, { useEffect, useState } from "react";
import SectionHeader from "./../Components/SectionHeader/SectionHeader";
import { productDatas } from "./../Datas/ProductDatas/ProductDatas";
import { useParams } from "react-router-dom";
import NoItemFound from "../Components/SiteComponants/NoItemFound";
import ProductPhoto from "../Components/ProductItem/ProductPhoto";
import ProductDetails from "../Components/ProductItem/ProductDetails";
import ProductDetailsBottom from "../Components/ProductItem/ProductDetailsBottom";
import { TitleSetup } from "./../Datas/Functions/titleSetup";
import BreadCrumbs from "../Components/BreadCrumbs/BreadCrumbs";

const ProductItem = (meta) => {
  const [productItem, setProductItem] = useState(null);
  const { pid } = useParams();
  TitleSetup({ ...meta });
  useEffect(() => {
    const newProd = productDatas.find((prd) => prd.id === pid);
    setProductItem(newProd);
  }, [pid]);

  return (
    <div className="w-full md:container mx-auto my-6 font-sans">
      {productItem ? (
        <>
          <SectionHeader heading={productItem?.name} />
          <BreadCrumbs texts={["Dashboard", "Products", productItem?.name]} />
          <div className="bg-front dark:dark-bg-front grid grid-cols-1 md:grid-cols-2 gap-5 my-5  mx-2  px-4 py-5 box ">
            <ProductPhoto productItem={productItem} />
            <ProductDetails productItem={productItem} />
          </div>
          <div className="box bg-front dark:dark-bg-front grid grid-cols-1 md:grid-cols-2 gap-5 my-5  mx-2  px-4 py-5 border rounded-lg">
            <ProductDetailsBottom productItem={productItem} />
          </div>
        </>
      ) : (
        <NoItemFound msg={"Product Name or ID does not match"} />
      )}
    </div>
  );
};

export default ProductItem;
